const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* ====== CLICK TRACKING: telefon (adaugat 2026-10-02; 2026-11-02: Meta doar cu acord de marketing, GA4 doar cu acord de statistici) ====== */
document.addEventListener('click', function (event) {
  var link = event.target && event.target.closest ? event.target.closest('a') : null;
  if (!link) return;
  var href = link.getAttribute('href') || '';
  if (href.indexOf('tel:') !== 0) return;
  var cp = window.Shopify && window.Shopify.customerPrivacy;
  var an = false, mk = false;
  try { an = !!(cp && cp.analyticsProcessingAllowed()); mk = !!(cp && cp.marketingAllowed()); } catch (e) {}
  if (an && typeof gtag === 'function') gtag('event', 'click_telefon', {event_category: 'contact', event_label: 'telefon'});
  if (mk && typeof fbq === 'function') fbq('trackCustom', 'ClickTelefon');
});
/* ====== /CLICK TRACKING: telefon ====== */
